module.exports = "/_next/static/images/bread-68b619fdc456d83d2ac5302569c83623.jpg";